const SIDE_AD_ROTATE_MS = 7000;

function initSideAdSlider(root) {
  const slides = Array.from(root.querySelectorAll('[data-side-ad-slide]'));

  if (slides.length <= 1) {
    return;
  }

  const intervalMs = Number(root.dataset.interval || SIDE_AD_ROTATE_MS);
  let currentIndex = Math.floor(Math.random() * slides.length);

  const showSlide = (index) => {
    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === index);
    });
  };

  showSlide(currentIndex);

  window.setInterval(() => {
    currentIndex = (currentIndex + 1) % slides.length;
    showSlide(currentIndex);
  }, intervalMs);
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-side-ad-slider]').forEach(initSideAdSlider);
});
